import { isProfileV2, PermissionRules, ROLES } from '@teamworksdev/influencer/core';

// Compliance Officer whose school has the local exchange feature enabled.
// Replaces the inline route guard that checked
// `role_id === COMPLIANCE_OFFICER && data.school.is_local_exchange_enabled`.
const complianceUserWithLocalExchangeEnabled = PermissionRules.custom((profile) =>
	isProfileV2(profile)
	&& profile.role_id === ROLES.COMPLIANCE_OFFICER
	&& profile.data.school.is_local_exchange_enabled,
);

export {
	complianceUserWithLocalExchangeEnabled,
};
